export const filterEmptyFields = <T extends Record<string, any>>(
  obj: T
): Partial<T> =>
  Object.fromEntries(
    Object.entries(obj).filter((entry) =>
      typeof entry[1] === 'boolean' ? true : Boolean(entry[1])
    )
  ) as Partial<T>;

export const omit = <T extends Record<string, any>, K extends keyof T>(
  obj: T,
  keysToOmit: K[]
): Omit<T, K> => {
  const newObj = { ...obj };
  for (const key of keysToOmit) {
    delete newObj[key];
  }
  return newObj as Omit<T, K>;
};
